import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setSelectedZone, TempChange, setzoneCount } from '../../../action/roomControlAction'
import { roomThemeColorConfig } from '../../JS/colorConfig'
import { CMSPath } from '../../../config/constant'

class SelectLightCurtainZone extends Component {

    componentDidMount() {
        roomThemeColorConfig(this.props.menuColor)
        this.checkForSingleZone({}, "first call");
    }
    componentDidUpdate(prePro) {
        this.checkForSingleZone(prePro, "");
    }

    checkForSingleZone = (prePro, firstcall) => {
        console.log("checkForSingleZone called")
        let count = 0, index = null
        if ((firstcall === "first call" || prePro.VDAZoneList !== this.props.VDAZoneList) && this.props.VDAZoneList.length !== 1) {
            this.props.VDAZoneList.map((iterator, ind) => {
                if (iterator.hvac && iterator.hvac.temperatureValue) {
                    ++count;
                    index = ind
                }
            })
            if (count === 1) {
                console.log("we have only one zone but shows two.");
                let temp = parseInt(this.props.VDAZoneList[index].hvac.temperatureValue.slice(2, 4));
                let roomTemp = parseInt(this.props.VDAZoneList[index].hvac.currentRoomTemperature.slice(2, 4));
                this.props.setSelectedZone(this.props.VDAZoneList[index], roomTemp, index);
                this.props.TempChange(null, temp);

            }
            this.props.setzoneCount(count);
            console.log("zone count", count)
        }
    }

    setZone = (zone, index) => {
        let temp = parseInt(zone.hvac.temperatureValue.slice(2, 4));
        let roomTemp = parseInt(zone.hvac.currentRoomTemperature.slice(2, 4));
        this.props.setSelectedZone(zone, roomTemp, index);
        this.props.TempChange(null, temp);
    }

    render() {
        return (
            <div>
                <section id="customizeRoom" class="widgets padding-bottom-2 margin-0">
                    <div class="widget-header widget-header-checkin">
                        { this.props.currentWidget.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidget.widgetHeaderImageUrl}`} alt={this.props.currentWidget.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{this.props.currentWidget.displayName}</div>
                    </div>


                    <div class="widgets">
                        <div class="row">
                            <div class="col">
                                <p class="heading">Select room</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col col-2 menu-items">
                                {
                                    this.props.VDAZoneList.length > 0 ?
                                        this.props.VDAZoneList.map((iterator, index) => {
                                            return (
                                                <a
                                                    onClick={() => this.setZone(iterator, index)}
                                                    className={
                                                        true ? "tile-sm thumbnails tile-container"
                                                            : "tile-sm thumbnails tile-container selected"
                                                    }>
                                                    <div class="thumb-img">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100.76 58.28"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M13.1,14.77a6.59,6.59,0,0,1,6.59,6.59v9.19H81.07V21.36a6.59,6.59,0,0,1,6.58-6.59h3V9.54A9.54,9.54,0,0,0,81.1,0H19.66a9.54,9.54,0,0,0-9.54,9.54v5.23Z"/><rect class="cls-1" y="16.71" width="17.23" height="34.85" rx="5.93"/><rect class="cls-1" x="83.53" y="16.71" width="17.23" height="34.85" rx="5.93"/><rect class="cls-1" x="19.65" y="32.66" width="61.45" height="18.9" rx="2.06"/><rect class="cls-1" x="3.45" y="53.78" width="10.32" height="4.5" rx="2.25"/><rect class="cls-1" x="86.98" y="53.78" width="10.32" height="4.5" rx="2.25"/></g></g></svg>
                                                    </div>
                                                    <div class="thumb-text align-center" style={{ color: "inherit" }}>
                                                    <p class="thumb-heading" style={{ color: "inherit" }}>{iterator.hvac && iterator.hvac.label ? iterator.hvac.label : `AC ${index}`}</p>
                                                    </div>
                                                </a>
                                            )
                                        }) : null
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        )
    }
}

const mapStateToProps = state => {
    return {
        currentPage: state.store2.roomControl.currentPage,
        guestDetail: state.store.home.guestDetails,
        currentWidget: state.store.sideNavBar.currentWidget,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        selectedZone: state.store.roomControl.selectedZone,
        menuColor: state.store.home.MenuColor,
    }
}
export default connect(
    mapStateToProps,
    {
        setSelectedZone,
        TempChange,
        setzoneCount
    }
)(SelectLightCurtainZone);